import { Injectable } from "@angular/core";
import { BlacklistItemsDataService } from "@mol-limo-reg/admin-api";
import { BlacklistItem, CreateBlacklistItemRequest } from "@mol-limo-reg/admin-api/model/models";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BlacklistService {

  constructor(private readonly blacklistDataService: BlacklistItemsDataService) {}

  public createBlacklistItem$(createBlacklistItemRequest: CreateBlacklistItemRequest): Observable<any> {
    return this.blacklistDataService.createBlacklistItem(createBlacklistItemRequest, 'body');
  }

  public deleteBlacklistItem$(id: string): Observable<any> {
    return this.blacklistDataService.deleteBlacklistItem(id, 'body');
  }

  public searchBlacklistItems$(email?: string, phoneNumber?: string, licenseNumber?: string, dateOfBirth?: string, addressCardNumber?: string): Observable<Array<BlacklistItem>> {
    return this.blacklistDataService.searchBlacklistItems(email, phoneNumber, addressCardNumber, licenseNumber, dateOfBirth, 'body');
  }
}
